var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import React, { forwardRef } from 'react';
import styled from 'styled-components';
export var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
export var Arrow = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 1rem;\n  height: 1rem;\n\n  &:before {\n    content: ' ';\n    position: absolute;\n    top: -0.6rem;\n    transform: rotate(45deg);\n    width: 1rem;\n    height: 1rem;\n    background-color: white;\n    border-right: 0.1rem solid ", ";\n    border-bottom: 0.1rem solid ", ";\n    box-shadow: 0.3rem 0.2rem 0.4rem 0 rgba(0, 0, 0, 0.16);\n  }\n"])), _ref => {
  var {
    theme
  } = _ref;
  return theme.colors.border;
}, _ref2 => {
  var {
    theme
  } = _ref2;
  return theme.colors.border;
});
export var PanelContainer = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  background-color: white;\n  border: 0.1rem solid ", ";\n  box-shadow: 0 0.2rem 0.4rem 0 rgba(0, 0, 0, 0.16);\n  border-radius: 0.4rem;\n  box-sizing: border-box;\n  min-width: 15rem;\n"])), _ref3 => {
  var {
    theme
  } = _ref3;
  return theme.colors.border;
});
export var PanelList = styled(
/*#__PURE__*/
// eslint-disable-next-line react/display-name
forwardRef((props, ref) => /*#__PURE__*/React.createElement("ul", _extends({
  ref: ref
}, props))))(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  list-style: none;\n  margin: 0;\n  padding: 0;\n"])));
export var PanelListItem = styled.li(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  padding: 1rem;\n  user-select: none;\n  box-sizing: border-box;\n\n  &:not(:last-child) {\n    border-bottom: 0.1rem solid ", ";\n  }\n\n  &:focus-within {\n    outline: 0.3rem solid ", ";\n  }\n\n  ", "\n"])), _ref4 => {
  var {
    theme
  } = _ref4;
  return theme.colors.border;
}, _ref5 => {
  var {
    theme
  } = _ref5;
  return theme.colors.dark;
}, _ref6 => {
  var {
    disabled
  } = _ref6;
  return disabled ? "\n            pointer-events: none;\n        " : "\n            &:hover {\n                background-color: #f3f4f4;\n                cursor: pointer;\n            }\n        ";
});
export var PanelListItemLabel = styled.label(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  margin-left: 1rem;\n  margin-bottom: 0;\n  font-size: 1.5rem;\n  line-height: 2.5rem;\n  font-weight: 600;\n"])));
export var TriggerButton = styled.button(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  font-family: 'Open Sans', sans-serif;\n  font-size: 1.6rem;\n  background-color: ", ";\n  border-radius: 0.4rem;\n  height: 3.6rem;\n  padding-left: 1rem;\n  padding-right: 1rem;\n  border: 0.1rem solid ", ";\n  box-shadow: 0 0.2rem 0.4rem 0 rgba(0, 0, 0, 0.16);\n  display: inline-block;\n  cursor: pointer;\n  text-align: center;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n"])), _ref7 => {
  var {
    theme
  } = _ref7;
  return theme.colors.background;
}, _ref8 => {
  var {
    theme
  } = _ref8;
  return theme.colors.border;
});
export var TriggerText = styled.span(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  margin-left: 0.7rem;\n\n  @media (max-width: 768px) {\n    display: none;\n  }\n"])));